import React, { useContext } from 'react';
import { compact, find } from 'lodash';
import { routes } from 'constants/config';
import { FilterContext } from 'components/shared/FilterContext';
import { Icon } from 'ui';
import DataCard from '../_shared/DataCard';

const InPersonTrainingReportContainer = () => {
  const { params: filter } = useContext(FilterContext);
  const withFilterQuery = url => compact([url, $.param(filter)]).join('?');
  const hasDateFilter = filter.start_date || filter.end_date;
  const hasGroupsFilter = filter.group_ids && filter.group_ids.length > 0;
  return (
    <DataCard.Container direction="column">
      <DataCard.Content
        title={t('insights.in_person_training.title')}
        subtitle={find([
          hasDateFilter &&
            hasGroupsFilter &&
            t('insights.in_person_training.subtitle_with_all_filters'),
          hasDateFilter &&
            t('insights.in_person_training.subtitle_with_date_filter'),
          hasGroupsFilter &&
            t('insights.in_person_training.subtitle_with_groups_filter'),
          t('insights.in_person_training.subtitle'),
        ])}
      >
        <a
          href={withFilterQuery(routes.INSIGHTS.IN_PERSON_TRAINING.REPORT)}
          className="DataCard-link"
        >
          <Icon name="download" /> {t('common.download')}
        </a>
      </DataCard.Content>
    </DataCard.Container>
  );
};

export default InPersonTrainingReportContainer;
